/**
 * 基盘导入
 */
import { CUSTOMERIMPORT } from '../types';

export default {
    name: `${CUSTOMERIMPORT}`,
    path: '/customerImport',
    component: () => import(/* webpackChunkName: 'customerImport' */ '@/views/customerImport/'),
    redirect: { name: `${CUSTOMERIMPORT}Index` },
    meta: {
        title: '基盘导入',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${CUSTOMERIMPORT}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'customerImport' */ '@/views/customerImport/home/Home.vue'),
        },
    ],
};
